import React from "react";
import styled from "styled-components";
import colors from "../design/colors";
import fonts from "../design/typography";

// 공식 GOATHEAVEN "cari aca" 로고(고트디자인 packages/logos/src/svg/aca.svg 원본) + ADMIN 칩.
// 크기는 font-size 하나로 조절한다: 칩 글자 1em, 로고 높이 2.2em.
const AdminBrand = ({ className }: { className?: string }) => (
  <Wrapper className={className}>
    <Logo src="/assets/image/cari_aca_logo.svg" alt="카리아카" />
    <Chip>ADMIN</Chip>
  </Wrapper>
);

export default AdminBrand;

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.6em;
  max-width: 100%;
  font-size: 10px;
`;

// 폭이 모자라면 로고만 비율을 지킨 채 줄어든다.
const Logo = styled.img`
  height: 2.2em;
  width: auto;
  min-width: 0;
  object-fit: contain;
  object-position: left center;
`;

const Chip = styled.span`
  flex: none;
  padding: 0.2em 0.55em;
  border-radius: 0.55em;
  background-color: ${colors.gray900};
  color: ${colors.white};
  font-family: ${fonts.title1Bold.fontFamily};
  font-size: 1em;
  line-height: 1.4;
  letter-spacing: 0.04em;
`;
